import { Column, Row } from '@cdab/scania/qpr/components'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  flex-wrap: nowrap;
  margin-top: 16px;
  margin-bottom: 8px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    flex-direction: column;
    margin-top: 0;
    margin-bottom: 0;
  }
`

export const StyledFirstButton = styled(TdsButton)`
  padding-right: 8px;
`

export const Title = styled.h3.attrs({
  className: 'tds-headline-03'
})`
  margin-bottom: 8px;
  margin-top: 8px;
`

export const StyledColumn = styled(Column)`
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 8px;
    margin-bottom: 4px;
  }
`

export const ToggleWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    padding-top: 4px;
    padding-bottom: 4px;
  }
`

export const ButtonMessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 16px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 12px;
  }
`

export const StyledSectionTitle = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
`

export const StyledButton = styled(TdsButton)`
  flex: 0.13;
  padding-right: 4px;
`

export const StyledTdsButton = styled(TdsButton)`
  padding-top: 12px;
  padding-bottom: 12px;
`

export const CheckboxWrapper = styled.div`
  margin-bottom: 4px;
`
